import { WhiteInstantSearchBuilder } from '@white-nl/instantsearch-components';

import PerfectFitHit from '../hits/PerfectFitHit';
import PerfectFitProductSkeleton from '../../components/result/PerfectFitProductSkeleton';

export default function initWhiteInstantSearchPerfectFit() {
  const perfectFit = document.getElementById('white-instant-search-perfect-fit');

  if (!perfectFit) {
    return;
  }

  const {
    indexName,
    publicUrl,
    refreshUrl,
    currentSite,
    productIds,
  } = perfectFit.dataset;

  if (!indexName
    || !publicUrl
    || !refreshUrl
    || !currentSite
    || !productIds
  ) {
    return;
  }

  const whiteInstantSearchPerfectFit = new WhiteInstantSearchBuilder();
  whiteInstantSearchPerfectFit
    .withSearchkit(
      indexName,
      publicUrl,
      '',
      refreshUrl,
    )
    .where(`siteId:${currentSite} AND (${JSON.parse(productIds).map((id: number) => `id:${id}`).join(' OR ')})`)
    .setHitsPerPage(24)
    .addHitComponent(
      [
        {
          component: PerfectFitHit,
          loadingComponent: PerfectFitProductSkeleton,
          noResultsComponent: PerfectFitProductSkeleton,
        },
      ],
    )
    .build()
    .show();
}
